import React from 'react';

import PeDependOn from '../components/PeDependOn';
import { autofill, Field } from 'redux-form';
import PeMoreInfo from '../components/PeMoreInfo';
import { BatteryFormData } from '../components/formData/BatteryFormData';

interface SummaryAttribute {
  readonly id: string,
  readonly partNumber: string,
  readonly name: string,
  readonly description: string,
  readonly qty: number,
  readonly salePrice: string,
  readonly price: string,
  readonly category: string | undefined,
  readonly cost?: number,
  readonly itemise: boolean;
}

export type FieldConditionAttribute = {
  readonly value: string,
  readonly fieldChild: Array<FieldAttribute>,
}

export type OptionAttribute = {
  readonly label: string,
  readonly value: string,
}

export type FieldAttribute = {
  readonly name: string,
  readonly dependOn?: string,
  readonly dependOnValue?: string,
  readonly component: any,
  readonly props?: any,
  readonly siblingField?: Array<string>,
  readonly condition?: Array<FieldConditionAttribute>,
}

const fieldRelative = [{
  name: "plumbing",
  relatives: ["connection_kit", "electrical", "free_methven", "provide_stc", "pickup_sitedelivery"]
}, {
  name: "choice_type_install",
  relatives: ["hot_cold_connections", "located_within", "additional_untempered", "concrete_pavers_tank", 
    "concrete_pavers_heatpump", "is_your_replacement_urgent", "new_place_choice", 
    "subsidies", "exist_hws_gt_3yr",
    "plumbing", "indicative_pricing", 
    "quote_showerhead", "connected_to_reticulated_gas", "bca_building"]
}, {
  name: "product_choice_type",
  relatives: ["exist_hws_gt_3yr", "indicative_pricing", 
  "quote_showerhead", "connected_to_reticulated_gas", "bca_building",
    "electric_storage_located", "solar_boosted"]
}, {
  name: "is_your_replacement_urgent",
  relatives: ["choice_type_product"]
}, {
  name: "choice_type_product",
  relatives: ["product_choice_type", "product_choice"]
}, {
  name: "electric_storage_located",
  relatives: ["where_about_inside", "where_about_outside", "compressor_unit"]
}, {
  name: "new_place_choice",
  relatives: ["existing_install_location", "install_location_access", "stair_access", "electrical_already", "drain_nearby"],
}, {
  name: "add_extras",
  relatives: ["formchoice_extra"],
}, {
  name:"note_select",
  relatives: ["select_note", 'customer_note']
}, {
  name:"prepared_by",
  relatives: ["sms_template"]
}, {
  name: "state",
  relatives: ["exist_hws_gt_3yr", "quote_showerhead", "connected_to_reticulated_gas", "bca_building"]
}, {
  name: "subsidies",
  relatives: ["indicative_pricing", "product_choice"]
}]

const fieldAutofill = [{
  name: "new_place_choice",
  value: "same_as_existing_hws",
  autofills: [{
    fieldName: "existing_install_location",
    value: "external_wall_house",
  }, {
    fieldName: "install_location_access",
    value: "easy_access",
  }, {
    fieldName: "stair_access",
    value: "no_stairs",
  }]
}
, {
  name: "choice_type_install",
  value: "replace_system",
  autofills: [{
    fieldName: "plumbing",
    value: "yes",
  }, {
    fieldName: "connection_kit",
    value: "15mm",
  }, {
    fieldName: "electrical",
    value: "yes",
  }]
}
, {
  name: "choice_type_install",
  value: "no_replace_system",
  autofills: [{
    fieldName: "plumbing",
    value: "yes",
  }, {
    fieldName: "connection_kit",
    value: "15mm",
  }, {
    fieldName: "electrical",
    value: "no",
  }]
}
]

export const renderField = (items: Array<FieldAttribute>, formValues: any, isAuth?: boolean) => {
  return items && items.map((item: FieldAttribute) => {
    var result;
    // Don't have permission
    if (item.props?.isAuth && !isAuth) {
      return false;
    }
    // Not form field
    if (item.name.indexOf('_moreinfo') !== -1) {
      result = <PeMoreInfo name={item.name} {...item.props}/>
    } else {
      // single field
      result = <Field id={`node_${item.name}`} key={item.name} name={item.name} component={item.component} {...item.props}/>
    }
    // depend on
    if (item.dependOn) {
      result = <PeDependOn key={"dependOn_" + item.name} dependOn={item.dependOn} value={item.dependOnValue}>
        {result}
        {item.siblingField && item.siblingField.map((sibling: string) => { 
          return <Field id={`node_${sibling}`} key={sibling} name={sibling} component="input" type="hidden"/>
        })}
      </PeDependOn>;
    }
    
    return <div key={"div_" + item.name}>
      {result}
      {item.condition && item.condition.map((con: FieldConditionAttribute) => {
        if (con.value === '') {
          return renderField(con.fieldChild, formValues);
        }
        if (formValues && typeof formValues[item.name] !== 'undefined' && con.value === formValues[item.name]) {
          return renderField(con.fieldChild, formValues);
        }
        return false;
      })}
    </div>
  })
}

export const handleFieldChange = (currField: string, dispatch: any, formName: string, fieldValue: string) => {
  clearField(currField, dispatch, formName);
  autoFillValue(currField, dispatch, formName, fieldValue);
}

const clearField = (currField: string, dispatch: any, formName: string) => {
  fieldRelative.map((item: any) => {
    if (currField === item.name) {
      return item.relatives.forEach((field: string)=>{
        if (field) {
          dispatch(autofill(formName, field, ""));
        }
        return clearField(field, dispatch, formName);
      });
    }
    return false;
  });
}

const autoFillValue = (currField: string, dispatch: any, formName: string, fieldValue: string) => {
  fieldAutofill.forEach((item: any) => {
    if (currField === item.name && fieldValue === item.value) {
      item.autofills.forEach((relative: any) => {
        dispatch(autofill(formName, relative.fieldName, relative.value));
      });
    }
  });
}

export const getOptionLabelByValue = (options: Array<OptionAttribute>, searchValue: string) => {
  return options && options.map((item: OptionAttribute) => {
    if (item.value === searchValue) {
      return item.label;
    }
    return false;
  })
}

const convertNumberToMoney = (num: number) => {
  let formatNum = new Intl.NumberFormat('en-US',
    { style: 'currency', currency: 'USD' }
  ).format(num).replace(/\D00(?=\D*$)/, '');
  if (formatNum.indexOf('-$') !== -1) {
    return formatNum.replaceAll('-$', '$-');
  }
  return formatNum;
}

const getProductByPartNumber = (products: any, partNumber: string, subsidy?: boolean) => {
  var product;
  if (subsidy) {
    product = products.filter((product: any) => product.partNumber === partNumber)[0];
  } else {
    product = products.filter((product: any) => product.part_number === partNumber)[0];
  }
  return product ? {
    ...product,
    part_number: subsidy ? product.partNumber : product.part_number,
    cost: parseFloat(product.cost)
  } : { cost: 0 };
}

const getSummaryItem = (product: any, qty: number, salePrice?: number, category?: string, cost?: number, itemise?: boolean) => {
  let item: SummaryAttribute = {
    id: product.id,
    partNumber: product.part_number,
    name: product.name,
    description: product.description,
    qty: qty,
    salePrice: salePrice ? convertNumberToMoney(salePrice) : "-",
    price: salePrice ? convertNumberToMoney(salePrice * qty) : "-",
    category: category,
    cost: cost,
    itemise: typeof itemise !== 'undefined' ? itemise : true,
  }
  return item;
}

const getSummaryPricingOption = (product: any, qty: number) => {
  return {
    id: product.id,
    name: product.productName,
    qty: qty,
    partNumber: product.partNumber,
  }
}

const getCost = (cost: any) => {
  return typeof cost == "string" ? parseFloat(cost) : cost;
}

const roundTo90 = (val: any) => {
  let strNum = typeof val == "string" ? val.replaceAll(',','').split('.')[0] : val.toString().replaceAll(',','').split('.')[0];
  let firstDigit = strNum.substr(0, strNum.length - 2);
  let last2Digit = strNum.substr(strNum.length - 2, strNum.length);
  // alway UP if last 2 digit > 90
  if(parseInt(last2Digit) > 90){
      return parseFloat((parseFloat(firstDigit) + 1) + "90.00");
  }
  // round to **90.00
  return parseFloat(firstDigit + "90.00");
}

const goSeek = (rebatePrice: number, totalPrice: number) => {
  let totalPrice90: number = roundTo90(totalPrice);
  let result: any = {};
  result['totalPrice90'] = totalPrice90;
  result['subPrice90'] = (totalPrice90 - rebatePrice) / 1.1;
  return result;
}

export const renderSummary = (formValues: BatteryFormData, productData: any, optionItem: any) => {
  let summary: any = {};
  let result: Array<any> = [];
  let product: any;
  let subPrice = 0,
  rebatePrice = 0,
  key = '',
    // priceState = 100, 
  extraPrice = 0,
  adminPe = 0.22;
  let {
    formchoice_extra,
    subsidies,
  } = formValues;


  try {
    // Add Install & Supply
    let subsidyJson = subsidies ? JSON.parse(subsidies) : {};
    product = getProductByPartNumber(productData.installs, 'BATTERY_SUPPLY_INSTALL', false);
    product && result.push(getSummaryItem(product, 1, 0, 'installs', 0, true));


    const { products, accessories, extras, isSend, grandTotalBat, capacity, pm, installBat, install_qty } = optionItem;
    
    products.forEach((item: any) => {
      product = getProductByPartNumber(productData.batteries, item.partNumber, false);
      // console.log(product);
      if(product && product['part_number']) {
        subPrice += getCost(product["cost"]) * (item.qty ? item.qty : 1);
        result.push(getSummaryItem(product, item.qty, 0, 'products', 0, true));
      }
    });

    accessories.forEach((item: any) => {
      product = getProductByPartNumber(productData.accessories, item.partNumber, false);
      if(product && product['part_number']) {
        subPrice += getCost(product["cost"]) * (item.qty ? item.qty : 1);
        result.push(getSummaryItem(product, item.qty, 0, 'accessories', 0, true));
      }
    });

    extras.forEach((item: any) => {
      product = getProductByPartNumber(productData.extras, item.partNumber, false);
      if(product && product['part_number']) {
        subPrice += getCost(product["cost"]);
        result.push(getSummaryItem(product, 1, 0, 'extras', 0, true));
      }
    });

    // /** Extra */
    let extraJson = formchoice_extra ? JSON.parse(formchoice_extra) : {};
    for (key in extraJson) {
      if (extraJson.hasOwnProperty(key)) {
        product = getProductByPartNumber(productData.extras, key);
        // calc price
        extraPrice += parseFloat(extraJson[key]["cost"]);
        result.push(getSummaryItem(product, 1, undefined, "extras", parseFloat(extraJson[key]["cost"]), extraJson[key]["itemise"]));
      }
    }
    product = getProductByPartNumber(productData.installs, 'BATTERY_STORAGE_BOS', false);
    if(product && product['part_number']) {
      subPrice += getCost(product["cost"]);
      result.push(getSummaryItem(product, 1, 0, 'installs', 0, false));
    }

    product = getProductByPartNumber(productData.installs, 'BATTERY_STORAGE_INSTALL', false);
    if(product && product['part_number']) {
      subPrice += getCost(product["cost"])*(install_qty && installBat === "Yes" ? install_qty - 1 : 1);
      result.push(getSummaryItem(product, (install_qty && installBat === "Yes" ? install_qty - 1 : 1), 0, 'installs', 0, false));
    }

    if(installBat == "Yes") {
      product = getProductByPartNumber(productData.installs, 'Freight_Battery_Storage', false);
      if(product && product['part_number']) {
        subPrice += getCost(product["cost"])*(install_qty ? install_qty - 1 : 1);
        result.push(getSummaryItem(product, install_qty ? install_qty - 1 : 1, 0, 'installs', 0, false));
      }

      product = getProductByPartNumber(productData.installs, 'T_B_L_K', false);
      if(product && product['part_number']) {
        subPrice += getCost(product["cost"])*(install_qty ? install_qty - 1 : 1);
        result.push(getSummaryItem(product, install_qty ? install_qty - 1 : 1, 0, 'installs', 0, false));
      }
    }

    /** Rebate, STC, VEEC... */
    let rebateArr = {};
    // Solar Vic Solar Hot Water Rebate - Do you qualify?
    if (subsidyJson["SVic_Bat_Sto_Rebate"] && subsidyJson["SVic_Bat_Sto_Rebate"].isChecked) {
      product = getProductByPartNumber(productData.subsidies, "SVic_Bat_Sto_Rebate", true);
      result.push(getSummaryItem(product, 1, product["cost"], "rebates", undefined, false));
      rebatePrice += product["cost"];
      rebateArr = {
        ...rebateArr,
        [product["name"]]: convertNumberToMoney(product["cost"])
      }
    }

    summary = {
      result: result,
      isSend: isSend,
      capacity: capacity ? capacity : 0,
      grandTotal: convertNumberToMoney(parseFloat(grandTotalBat.replaceAll(',',''))),
    }
  

    // /** Calculate price */ 
    subPrice += extraPrice;
    // Pe Admin 19%
    subPrice += (subPrice * adminPe);

    // // Round to 90 and go seek

    let goSeekVal = goSeek(0, subPrice + 0 + (subPrice * 0.1));
    
    // First line
    result[0] = {
      ...result[0],
      salePrice: convertNumberToMoney(goSeekVal.subPrice90 + (goSeekVal.subPrice90 * 0.1)),
      price: convertNumberToMoney(goSeekVal.subPrice90 + (goSeekVal.subPrice90 * 0.1)),
    }

    summary["result"] = result;

     // Rebate Array
    summary["rebate"] = rebateArr;

    // // Sub total
    summary["subTotal"] = convertNumberToMoney(goSeekVal.subPrice90 + (goSeekVal.subPrice90 * 0.1));
    
    // // Total Price
    summary["totalPrice"] = convertNumberToMoney(goSeekVal.totalPrice90);

    // // PDF
    summary["pdf"] = {};
    summary["pdf"]["firstLine"] = convertNumberToMoney(goSeekVal.subPrice90);
    summary["pdf"]["subTotal"] = convertNumberToMoney(goSeekVal.subPrice90);
    summary["pdf"]["gst"] = convertNumberToMoney(goSeekVal.subPrice90 * 0.1);;
    
    return summary;

  } catch (err) {
    console.log(err);
  }
}